export default __webpack_public_path__ + "static/media/whatsapp.27d3105f.svg";